export default __webpack_public_path__ + "static/media/aequalis20.c493b148.pdf";